import React from 'react';
import Contenido from '../../../layout/Contenido';
import { useSelector } from 'react-redux';
import TablaPedidos from '../../tablas/TablaPedidos';
import { getPedidosCompletosEstadosUnidos } from '../../../utils';
import { blue } from '@material-ui/core/colors';

export default function Estadosunidos() {
	const { fetching, ultimaActualizacion, pedidos } = useSelector(
		(content) => content.Pedidos
	);

	return (
		<Contenido title='Pedidos de Estados Unidos' color={blue[700]}>
			<div
				style={{
					height: '100%',
					width: '100%',
				}}>
				<TablaPedidos
					loading={fetching && ultimaActualizacion === null}
					pedidos={getPedidosCompletosEstadosUnidos(pedidos)}
					showBloquear={true}
					showPreparar={true}
					showPedidosATienda={true}
					pdfTitle='Pedidos de Estados Unidos'
				/>
			</div>
		</Contenido>
	);
}
